import React from 'react';
import { motion } from 'framer-motion';
export function ProductIntro() {
  const levels = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2+Niños'];
  return <section className="w-full bg-deep-green py-20 px-4 text-white overflow-hidden" data-id="element-286">
      <div className="max-w-4xl mx-auto text-center" data-id="element-287">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-288">
          <div className="inline-block bg-gold/20 text-gold border border-gold/30 text-xs font-bold px-4 py-1.5 rounded-full mb-8 uppercase tracking-wider" data-id="element-289">
            🏆 Sistema N°1 para Docentes de Português en Argentina
          </div>

          <h2 className="text-5xl md:text-6xl font-extrabold mb-4 tracking-tight" data-id="element-290">
            🇧🇷 PORTUGUÉS 360™
          </h2>

          <h3 className="text-2xl md:text-3xl text-gold font-bold mb-8" data-id="element-291">
            MEGAPACK COMPLETO
          </h3>

          <p className="text-lg md:text-xl text-green-50 max-w-2xl mx-auto leading-relaxed mb-12" data-id="element-292">
            340+ páginas. 12 tomos por nivel. 6 bonus estratégicos. Rúbricas,
            evaluaciones y secuencias didácticas listas para usar desde hoy.
          </p>

          {/* Level Pills */}
          <div className="flex flex-wrap justify-center gap-3" data-id="element-293">
            {levels.map((level, i) => <motion.div key={level} initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-gold text-deep-green font-bold px-5 py-2 rounded-full text-sm shadow-md" data-id="element-294">
                {level}
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}